import { Component, inject, OnInit, signal } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { checkRut } from "../../../utils/client-utils";
import { AdminInvoicingInfoService } from "./admin-invoicing-info.service";
import { AdminService } from "../../services/admin.service";
import { catchError, EMPTY } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'app-admin-invoicing-info',
  templateUrl: './admin-invoicing-info.component.html',
  styleUrls: ['./admin-invoicing-info.component.scss',  '../admin-main.common.scss'],
  standalone: false,
})
export class AdminInvoicingInfoComponent implements OnInit {

  private readonly adminService = inject(AdminService);

  private readonly fb = inject(FormBuilder);

  private readonly invoicingInfoService = inject(AdminInvoicingInfoService);

  private readonly snackBar = inject(MatSnackBar);

  private invoicingInfoServiceId = signal<number | undefined>(this.adminService.local$.getValue()?.invoicing_info?.id);


  public form = this.fb.group({
    company_name: this.fb.control(null, Validators.required),
    rut: this.fb.control(null, [Validators.required, checkRut]),
    activity: this.fb.control(null, Validators.required),
    city: this.fb.control(null, Validators.required),
    district: this.fb.control(null, Validators.required),
    address: this.fb.control(null, Validators.required),
    legal_representative_name: this.fb.control(null, Validators.required),
    legal_representative_rut: this.fb.control(null, [Validators.required, checkRut]),
    electronic_signature_url: this.fb.control(null, Validators.required),
    rut_front_url: this.fb.control(null, Validators.required),
    rut_back_url: this.fb.control(null, Validators.required),
  });

  saving = signal<boolean>(false);

  ngOnInit(): void {
    if (this.invoicingInfoServiceId()) {
      this.form.patchValue(this.adminService.local$.getValue()?.invoicing_info)
    }
  }

  public saveForm(): void {
    this.saving.set(true);
    console.log(this.form);

    if (this.invoicingInfoServiceId()) {
      this.invoicingInfoService.update(this.invoicingInfoServiceId(), this.form.value).pipe(
        catchError(() => {
          this.snackBar.open('Error al actualizar la información de facturación', 'Cerrar', {
            duration: 3000,
            panelClass: ['snackbar-error'],
          });
          this.saving.set(false);

          return EMPTY;
        }),
      ).subscribe(() => {
        this.saving.set(false);

        this.snackBar.open('Información de facturación actualizada correctamente', 'Cerrar', {
          duration: 3000,
          panelClass: ['snackbar-success'],
        });
      });

    } else {
      this.invoicingInfoService.create(this.form.value).pipe(
        catchError(() => {
          this.snackBar.open('Error al crear la información de facturación', 'Cerrar', {
            duration: 3000,
            panelClass: ['snackbar-error'],
          });
          this.saving.set(false);
          return EMPTY;
        }),
      ).subscribe((response: any) => {
        this.saving.set(false);
        this.snackBar.open('Información de facturación creada correctamente', 'Cerrar', {
          duration: 3000,
          panelClass: ['snackbar-success'],
        });
        this.invoicingInfoServiceId.set(response.body.id);
      });

    }
  }

}
